export const SET_CARD_INFO = 'SET_CARD_INFO'
export const PENDING_CARD_INFO_ACTION = 'PENDING_CARD_INFO_ACTION'
